import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { QExpandableDataTable } from '../../shared';
import { type LicensedAgent } from '../api/getLicensedAgents';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
  items: {
    type: [] as PropType<LicensedAgent[] | null>,
    required: true,
  },
},
  setup(__props) {



const columns = [
  {
    text: 'Recruit',
    value: 'Recruit',
  },
  {
    text: 'Upline Agent',
    value: 'UplineAgent',
  },
  {
    text: 'Baseshop Owner',
    value: 'BaseshopOwner',
  },
  {
    text: 'SFG Direct',
    value: 'SFGDirect',
  },
  {
    text: 'Contract Submit Date',
    value: 'ContractSubmitDate',
  },
  {
    text: 'Licensed',
    value: 'Licensed',
    align: 'center',
  },
]

return { __sfc: true,columns, QExpandableDataTable }
}

})